import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userToken: "",
  profile: {},
  isLogin: false,
  ageRange: 120,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.userToken = action.payload;
    },
    setProfile: (state, action) => {
      return {
        ...state,
        isLogin: Boolean(action.payload.isLogin),
        profile: {
          ...state.profile,
          isLogin: action.payload.isLogin,
          phoneNumber: action.payload.phoneNumber,
          ...action.payload.profileItems,
        },
      };
    },
    setUpdateProfile: (state, action) => {
      return {
        ...state,
        profile: {
          ...state.profile,
          firstName: action.payload.firstName,
          lastName: action.payload.lastName,
          city: action.payload.city,
          state: action.payload.state,
          email: action.payload.email,
        },
      };
    },
    setUpdateProfileImage: (state, action) => {
      const { profileId, profileImage } = action.payload;
      if (profileId && state.profile.profiles) {
        state.profile.profiles = state.profile.profiles.map((p) =>
          p._id === profileId ? { ...p, profileImage } : p,
        );
      } else {
        // Fallback: set on user level (legacy)
        state.profile.profileImage = profileImage;
      }
    },
    setLogin: (state) => {
      state.isLogin = true;
    },
    setAgeRange: (state, action) => {
      state.ageRange = action.payload;
    },
    clearAuthState: () => ({ ...initialState, profile: {} }),
    restoreState: (state, action) => {
      const { user, token, isAuthenticated } = action.payload;
      if (token) state.userToken = token;
      if (user) state.profile = user;
      if (isAuthenticated !== undefined) state.isLogin = isAuthenticated;
    },
  },
});

export const {
  setAuth,
  setProfile,
  setLogin,
  setUpdateProfile,
  setUpdateProfileImage,
  setAgeRange,
  clearAuthState,
  restoreState,
} = authSlice.actions;
export default authSlice.reducer;
